import { ICommonResponse } from '../../types';

const CommonResponse = ({
  statusCode,
  errorCode,
  errorMessage,
  errorMetadata,
  response,
  headers,
  configRequest,
}: ICommonResponse): Promise<ICommonResponse> => {
  return Promise.resolve({
    statusCode,
    errorCode,
    errorMessage,
    errorMetadata,
    response,
    headers,
    configRequest,
  });
};

export default CommonResponse;
